import ListFilters from "@/common/components/ListFilters"
import { DatePickerWithRange } from "@/common/components/ui/dateRangePicker"
import { internalBaseEquipments } from "@/common/constants/internalBaseEquipments"
import { refundedStatus } from "@/common/constants/refundedStatus"
import { useProducts } from "@/common/hooks/queries/useProducts"
import useDebounce from "@/common/hooks/useDebounce"
import { useFilterParams } from "@/common/hooks/useFilterParams"
import { Mapper } from "@/common/services/mapper"
import { ProductData } from "@/features/products/types/product"

interface FilterProps {
  date: {
    from: Date | undefined;
    to: Date | undefined;
  }
}

const Filters = ({ date }: FilterProps) => {
  const { filterParams, setFilterParams } = useFilterParams({
    fromInternalBase: internalBaseEquipments.find(({ value }) => value === 'false')
  });

  const [productSearch, setProductSearch] = useDebounce('')

  const { data: productOptions } = useProducts({
    filters: { search: productSearch },
    mapper: Mapper.mapToOptions<ProductData>({ labelFieldName: 'display_name', valueFieldName: 'id' }),
  })

  return (
    <div className="flex gap-x-2">
      <DatePickerWithRange date={date} setDate={(date) => setFilterParams((prev) => ({ ...prev, date }))} />
      <ListFilters
        filters={[
          {
            className: 'min-w-40',
            onChange: (isRefunded: any) =>
              setFilterParams((prev) => ({ ...prev, isRefunded: isRefunded.value ? isRefunded : undefined })),
            value: filterParams.isRefunded,
            options: [{ label: 'Todos', value: '' }, ...(refundedStatus || [])],
            placeholder: 'Status',
          },
          {
            className: '',
            onInputChange: (e) => setProductSearch(e),
            onChange: (product: any) =>
              setFilterParams((prev) => ({ ...prev, product: product.value ? product : undefined })),
            value: filterParams.product,
            options: [{ label: 'Todos', value: '' }, ...(productOptions || [])],
            placeholder: 'Produtos'
          },
          {
            className: '',
            onChange: () => { },
            options: [{ label: 'Não implementado', value: '', isDisabled: true }],
            placeholder: 'Fatura'
          },
          {
            className: 'w-54',
            onChange: (e: any) =>
              setFilterParams((prev) => ({ ...prev, fromInternalBase: e.value ? e : undefined })),            
            value: filterParams.fromInternalBase,
            options: [{ label: 'Todos', value: '' }, ...(internalBaseEquipments || [])],
            placeholder: 'Exibir transações da base',
          }
        ]}
      />
    </div>
  )
}

export default Filters
